import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Gerekli bileşenleri kaydet
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip);

const CycleTimeLineChart = ({ data }) => {
  const [displayData, setDisplayData] = useState({ labels: [], values: [] });

  // Gelen veriyi işleyip sadece son 50 veriyi göster
  useEffect(() => {
    if (data && data.labels && data.values) {
      const labels = data.labels.slice(-150); // Son 50 etiketi al
      const values = data.values.slice(-150); // Son 50 değeri al
      setDisplayData({ labels, values });
    }
  }, [data]);

  const chartData = {
    labels: displayData.labels,
    datasets: [
      {
        label: "Çevrim Süresi (saniye)",
        data: displayData.values,
        backgroundColor: "#0071BC",
        borderColor: "#0071BC",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: { display: false },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Parçalar",
        },
      },
      y: {
        title: {
          display: true,
          text: "Çevrim Süresi (saniye)",
        },
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 h-96">
      <h3 className="text-lg font-bold text-gray-800">Çevrim Süresi</h3>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default CycleTimeLineChart;
